import type {
  IErrorResponse,
  SignUpVerifyOTPRequest,
  SignUpVerifyOTPResponse,
} from '@/types';

import { useMutation, type UseMutationResult } from '@tanstack/react-query';

import { urls } from '@/statics';
import { api } from '@/utils';

const useSignUpVerifyOtp = (): UseMutationResult<
  SignUpVerifyOTPResponse,
  IErrorResponse,
  SignUpVerifyOTPRequest
> => {
  return useMutation({
    mutationFn: (data) => api.post(urls.signUpVerifyOtp, data),
  });
};

export default useSignUpVerifyOtp;
